import { classNames } from "utils/common";

import type { Question } from "models";

type QuestionsColumnProps = {
  title: string;
  questions: Question[];
  onQuestionSelect: (question: Question) => void;
};

export const QuestionsColumn = ({ title, questions, onQuestionSelect }: QuestionsColumnProps) => (
  <>
    <h4>{title}</h4>

    <div className="questions-list">
      {questions.map(question => (
        <div key={question.id} className={`question-item ${classNames({ "is-inactive": !question.active })}`} onClick={() => onQuestionSelect(question)}>
          <span>{question.title}</span>

          {question.tags?.map(tag => (
            <span key={tag.id} className="question-tag" style={{ backgroundColor: tag.color }}>
              {tag.name}
            </span>
          ))}
        </div>
      ))}
    </div>
  </>
);
